export const toNumberRaw = (value: unknown, fallback = 0): number => {
  if (typeof value === 'number')
    return Number.isFinite(value) ? value : fallback;
  if (value == null) return fallback;

  const n = Number(value);
  return Number.isFinite(n) ? n : fallback;
};
